import { createFileRoute } from "@tanstack/react-router";

import { SettingsPage } from "@/features/Settings/SettingsPage";
import { GeneralTab } from "@/features/Settings/tabs/GeneralTab";

export const Route = createFileRoute("/_auth/settings/$siteId/general")({
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = Route.useParams();

  return (
    <SettingsPage
      title="General"
      description="Manage your organization, users, recommendations, and tracking."
      data-testid="settings-general-page"
    >
      <GeneralTab siteId={siteId} />
    </SettingsPage>
  );
}
